import React from "react";

export const Section = ({ children, className = "", id, testId }) => (
  <section id={id} data-testid={testId} className={`py-20 lg:py-32 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 lg:px-10">{children}</div>
  </section>
);

export const Overline = ({ children, className = "" }) => (
  <div className={`overline ${className}`}>{children}</div>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-serif-luxe text-4xl sm:text-5xl font-light tracking-tight text-[#F8F5EF] mt-3 mb-8 ${className}`}>{children}</h2>
);

export const GoldDivider = () => (
  <div className="flex items-center justify-center my-8">
    <div className="w-12 h-px bg-[#D4AF37]/40" />
    <div className="w-2 h-2 bg-[#D4AF37] rotate-45 mx-3" />
    <div className="w-12 h-px bg-[#D4AF37]/40" />
  </div>
);
